<template>
<div id="showresponsecode" style="width: 421px !important;">
    <!-- REQUEST -->
    <div style="display: flex; align-items: center; background: #F7F7F7 0% 0% no-repeat padding-box; border: 1px solid #DEDEDE; border-radius: 6px;width: 421px; height: 42px; margin: 16px 0 16px 0;">
        <!-- <Dropdown v-model="selectedCity" :options="cities" optionLabel="name" placeholder="Base URL" style="background: #F7F7F7 0% 0% no-repeat padding-box; border: border: 1px solid #DEDEDE; border-radius: 6px; height: 41px; border-radius: 6px 0px 0px 6px;" /> -->
        
        <div class="dropdownrequestcode">
            <button style="
                height: auto;
                height: 100%;
                border-radius: 6px 0px 0px 6px;
                display: flex;
                align-items: center;
                text-align: center;
                letter-spacing: -0.17px;
                color: #808184;
                font-size: 12px;
                cursor: pointer;
                width: 90px;
                height: 42px;
            "
                class="dropbtnrequestcode"
                @click="myFunction()"
            >
                <span style="display: inline; padding-top: 12px; padding-bottom: 12px; padding-right: 0px; padding-left: 10px;">
                    Base URL
                    <span style="margin-left: 8px;">
                        <i class="pi icon-technical-dropdown" style="background: #808184; width: 12px; height: 6px;"></i>
                    </span>
                </span>
            </button>
            <div id="myDropdownrequestcode" class="dropdown-content-filter-request-code">
                <div class="dropdown-container-request-code">
                    <div style="
                        font-size: 12px
                        font-family: var(--font-acumin-pro-light);
                        font-weight: 300;
                        letter-spacing: -0.17px;
                        color: #606B86;
                    ">
                        <div style="padding: 12px 12px 10px 12px">
                            Other requests
                        </div>
                        <div style="display: flex; flex-direction: column;">
                            <div v-for="server in servers" @click="selectServer(server)" style=" 
                        padding: 12px 12px 8px 12px; cursor: pointer;" :style="{'background': server.label === selectbaseurl.label ? '#DEDEDE': ''}">
                                <div style="
                                width: 200px;
                                padding: 0;
                                overflow: hidden;
                                position: relative;
                                display: inline-block;
                                text-align: center;
                                text-decoration: none;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                cursor: pointer;">
                                {{ server.url }}
                                </div>
                                <span style="right: 0; position: absolute; margin-right: 12px;" v-if="server.label === selectbaseurl.label">
                                    <i class="pi icon-technical-check" style="width: 11px; height: 8px; background: #606B86 0% 0% no-repeat padding-box;"></i>
                                </span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        
        <!-- <button class="dropbtnrequestcode" style="width: 100%; background: #F7F7F7 0% 0% no-repeat padding-box;">
            <span style="display: inline;">
                <span style="
                    height: auto;
                    height: 100%;
                    border-radius: 6px 0px 0px 6px;
                    border-right: 1px solid #DEDEDE;
                    display: flex;
                    align-items: center;
                    text-align: center;
                    padding: 0px 8px 0px 8px;
                    letter-spacing: -0.17px;
                    color: #808184;
                    font-size: 12px;
                "
            
                >   Ejemplos
                    <span style="margin-left: 8px;">
                        <i class="pi icon-technical-dropdown" style="background: #808184; width: 12px; height: 6px;"></i>
                    </span>
                </span>
            </span>
        </button> -->
        <div style="border-left: 1px solid #DEDEDE;">
            <input :value="selectbaseurl.url" style="background: #F7F7F7; width: 19.5rem; font-size:14px; letter-spacing: -0.2px; color: #606B86; padding-left: 16px; border: 0px !important; margin: 12px 0px 12px 0px;"></input>
        </div>
  <!-- <input :value="url" style="font-size:14px; letter-spacing: -0.2px; color: #606B86; padding-left: 16px; overflow: visible;
white-space: nowrap; 
  overflow-x: scroll;">{{url}}</input> -->
    </div>
    <div class="language-request extra-class" style="border-radius: 6px !important; background: #2A343A;">
        <div style="text-align: left; padding: 0px 16px 0px 16px; border: 1px solid #6D7278; height: 35px !important; display: flex; text-align-center; align-items: center; border-radius: 6px 6px 0px 0px;">
            <span style="
                font-size: 14px;
                font-weight: 600;
                letter-spacing: -0.2px;
                color: #C4C4C4;
                font-family: var(--font-acumin-pro-semibold);
                top: 1px;
                position: relative;
            ">
                Request
            </span>
            <!-- <Dropdown v-model="selectedCity" :options="cities" optionLabel="name" placeholder="# Nombre librería" style="background: #2A343A; border: 0px; color: #C4C4C4 !important; top: -15px; height: 30px;" class="p-dropdown-label-1"/> -->
            <!-- <i class="pi icon-technical-expand" style="width: 14px; height: 20px; background: #C4C4C4; margin-right: 16px; cursor: pointer;" :style="{'rotate': !openCard ? '180deg' : ''}" @click="handleHeight()"/>
            <i id="button1" class="pi icon-technical-copy" style="width: 18px; height: 20px; background: #C4C4C4; cursor: pointer;" @click="CopyToClipboard('div1')" /> -->
        </div>
        <!-- <pre class="language-js code-copy-added" style="height: 254px; border-radius: 6px;"> -->
            <div id="div1">
                <slot></slot>
            </div>
            <!-- <code id="div1">
                <span class="token keyword">function</span> <span class="token function">doSum</span><span class="token punctuation">(</span><span class="token parameter">x<span class="token punctuation">,</span> y <span class="token punctuation">,</span> z</span><span class="token punctuation">)</span><span class="token punctuation">{</span>
                    console<span class="token punctuation">.</span><span class="token function">log</span><span class="token punctuation">(</span><span class="token string">"The sum is "</span><span class="token punctuation">)</span>
                    console<span class="token punctuation">.</span><span class="token function">log</span><span class="token punctuation">(</span>x<span class="token operator">+</span>y<span class="token operator">+</span>z<span class="token punctuation">)</span>
                    console<span class="token punctuation">.</span><span class="token function">log</span><span class="token punctuation">(</span><span class="token string">"The average is: "</span><span class="token punctuation">)</span>
                    console<span class="token punctuation">.</span><span class="token function">log</span><span class="token punctuation">(</span><span class="token punctuation">(</span>x<span class="token operator">+</span>y<span class="token operator">+</span>z<span class="token punctuation">)</span><span class="token operator">/</span><span class="token number">3</span><span class="token punctuation">)</span>
                <span class="token punctuation">}</span>

                <span class="token comment">//function call</span>
                <span class="token function">doSum</span><span class="token punctuation">(</span><span class="token number">10</span><span class="token punctuation">,</span> <span class="token number">20</span><span class="token punctuation">,</span> <span class="token number">30</span><span class="token punctuation">)</span>
            </code> -->
        <!-- </pre> -->
        <div style="border: 1px solid #6D7278; height: 37px !important; text-align: left; border-radius: 0px 0px 6px 6px;">
            <i id="button1" class="pi icon-technical-copy" style="width: 18px; height: 20px; background: #C4C4C4; cursor: pointer; margin: 7px 16px 7px 16px;" @click="CopyToClipboard('div1')" />
        </div>
    </div>
</div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
export default {
    name: 'ShowCode',
    components: { Dropdown },
    props: {
        url: {
            type: String,
            default: 'https://{{hostname}}/t1-as-trx-web/rest/{{version}}/entitlement/approvals/admin/reject/{{trxRequestId}}'
        },
        servers: {
            type: Array,
            default: () => [
                { 'url': 'https://{{hostname}}/msvc-sec-commons/{{msvc-version}}/session/{{flowId}}/variables', 'label': 'Request correspondiente', 'description': 'Request de ejemplo 1'},
                { 'url': 'https://{{hostname}}/msvc-sec-commons/{{msvc-version}}/session/variables', 'label': 'Request sin el flujo', 'description': 'Request de ejemplo 2'}
            ]
        },
    },
    data: () => {
        return {
            selectbaseurl: {},
            selectedCity: null,
            cities: []
        }
    },
    mounted() {
        this.selectbaseurl = this.servers ? this.servers[0] : {}
        if (this.selectbaseurl.label) {
            window.document.getElementById(this.selectbaseurl.label).classList.toggle("show-request-codes")
        }
    },
    methods: {
        myFunction() {
            window.document.getElementById("myDropdownrequestcode").classList.toggle("showrequestcode")
        },
        selectServer(server) {
            this.myFunction()
            this.showRequest(server)
        },
        showRequest(server) {
            if (server.label !== this.selectbaseurl.label) {
                if (this.selectbaseurl.label) {
                    window.document.getElementById(this.selectbaseurl.label).classList.remove("show-request-codes")
                }
                window.document.getElementById(server.label).classList.toggle("show-request-codes")
            }
            this.selectbaseurl = server
        },
        cleanRequest() {
            this.selectbaseurl = {}
            this.servers.map((x) => {
                window.document.getElementById(x.label).classList.remove("show-request-codes")
            })
            this.myFunction()
        },
        CopyToClipboard(containerid) {
            var range = document.createRange();
            range.selectNode(document.getElementById(this.selectbaseurl.label));
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges();// to deselect
        }
    }
}
</script>
<style lang="stylus">
#showresponsecode {
    pre, pre[class*="language-"] {
        height: 182px !important;
        border-radius: 0px !important;
    }
}
input:focus-visible {
    display: none;
}

.dropdown-request {
}

.dropbtnrequestcode
  width: 100%;
  height: auto !important;
  background-color: #F7F7F7;
  color: white;
  // padding: 12px 12px 12px 16px;
  // border: 1px solid #F3F7F8;
  cursor: pointer;
  border-top: 0px solid #e2e2e2;
  border-bottom: none;
  border-right: none;
  border-left: none;

.dropbtnrequestcode:hover, .dropbtnrequestcode:focus {
  background-color: #F7F7F7;
}

.dropbtnrequestcode:focus-visible {
  outline: none
}

.dropdownrequestcode {
  position: relative;
  display: inline-block;
  width: auto;
}

.dropdown-content-filter-request-code {
  display: none;
  position: absolute;
  width: 10rem;
  border: 1px solid #DEDEDE;
  border-radius: 0px 6px 6px 6px;
  overflow: auto;
  left: 0;
  margin-top: 0;
  background: #F4F4F4 0% 0% no-repeat padding-box;
  width: 242px;
  margin-top: 1px;
  z-index: 2;
}

.dropdown-content-filter-request-code a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  width 100%
  z-index: 88888888;
}

.dropdown-request-code a:hover {background: #EEEEEE 0% 0% no-repeat padding-box;}

.showrequestcode {
    display: block;
}

.dropdown-container-request-code {
}

.hidden-request-codes {
    display: none;
    position: absolute;
    background: #F4F4F4 0% 0% no-repeat padding-box;
    z-index: 1;
}

.show-request-codes {
    display: block;
    position: relative;
}

</style>
